var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group"},[_c('h2',[_vm._v(_vm._s(_vm.info.name))]),_c('ul',_vm._l((_vm.info.websites),function(item){return _c('li',{key:item.title},[_c('item',{attrs:{"website":item}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }